import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutRoutingGuideList extends Layout {
    labelPageTitle: Label;
    sourceRoutingGuideProfile: DataSource;
    tableRoutingGuideList: Table;
}
